import { AppLayout } from "@/components/layout/AppLayout";
import { ArticleCard } from "@/components/launchkit/ArticleCard";
import { getFreeArticles, getLockedArticles } from "@/data/launchKitArticles";
import { Rocket, Lock } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LaunchKitWelcomeBanner } from "@/components/launchkit/WelcomeBanner";

export default function LaunchKit() {
  const freeArticles = getFreeArticles();
  const lockedArticles = getLockedArticles();

  return (
    <AppLayout>
      <div className="p-4 md:p-8">
        {/* Welcome Banner */}
        <div className="mb-8">
          <LaunchKitWelcomeBanner />
        </div>

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground flex items-center gap-3">
            <Rocket className="h-8 w-8 text-primary" />
            Launch Kit
          </h1>
          <p className="text-muted-foreground mt-1">
            Everything you need to start and grow your Turo business
          </p>
        </div>

        {/* Free Articles Section */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold text-foreground mb-4">Getting Started</h2>
          <p className="text-muted-foreground mb-6">
            Free guides to help you launch your first listing and start earning.
          </p>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {freeArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>

        {/* Premium Upsell Card — hidden until launch kit purchase is enabled
        <Card className="mb-8 border-primary/20 bg-gradient-to-r from-primary/5 to-primary/10">
          <CardHeader>
            <div className="flex items-center gap-2">
              <Lock className="h-5 w-5 text-primary" />
              <CardTitle>Unlock the Full Launch Kit</CardTitle>
            </div>
            <CardDescription className="text-base">
              Get lifetime access to our complete educational library with a single purchase.
            </CardDescription>
            <p className="text-sm text-foreground/80 mt-2 italic">
              We'll guide you from knowing nothing to fully up and running on Turo—and beyond.
            </p>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-6">
              Unlock all Advanced Strategies below, plus any new or updated educational content we release in the future.
            </p>
            <p className="text-sm text-muted-foreground text-center mb-2">Coming soon</p>
            <Button 
              className="w-full"
              disabled
            >
              Get Launch Kit - $49
            </Button>
            <p className="text-xs text-muted-foreground text-center mt-3">
              One-time payment. Access forever.
            </p>
          </CardContent>
        </Card>
        */}

        {/* Locked Articles Section — hidden until launch kit purchase is enabled
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-4">Advanced Strategies</h2>
          <p className="text-muted-foreground mb-6">
            Premium content for hosts ready to scale their business.
          </p>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {lockedArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
        */}
      </div>
    </AppLayout>
  );
}
